import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { Gauge } from "lucide-react";

const AEMcrLoadComparisonChart = ({ aeSfocVsRpmConsData }) => {
  const [selectedChart, setSelectedChart] = useState("sfoc");
  const selectedAE = useSelector((state) => state.ae.selectedAE);
  const chartRef = useRef(null);
  console.log("aeSfocVsRpmConsData:", aeSfocVsRpmConsData);

  const scatterData = aeSfocVsRpmConsData?.chartData?.map((point) => ({
    x: point.load,
    y: selectedChart === "sfoc" ? point.sfoc : point.rpm,
    name: point.name || `${point.load}% Load`,
  })) || [];

  const aeColors = {
    ae1: "#1a5276",
    ae2: "#d35400",
    ae3: "#27ae60",
    ae4: "#7d3c98",
    ae5: "#a93226",
    ae6: "#b7950b",
  };

  const getSeriesColor = () => aeColors[selectedAE] || "#1a5276";

  const options = {
    chart: { type: "scatter", height: 400, backgroundColor: "transparent" },
    title: { text: null },
    credits: { enabled: false },
    xAxis: {
      title: { text: "Load (%)", style: { color: "#666666" } },
      min: 0,
      max: 100,
      tickInterval: 10,
      gridLineWidth: 1,
      gridLineColor: "#f0f0f0",
      lineColor: "#ccd6eb",
      lineWidth: 1,
    },
    yAxis: [{
      title: { text: selectedChart === "sfoc" ? "SFOC (g/kWh)" : "RPM", style: { color: "#666666" } },
      min: selectedChart === "sfoc" ? 0 : 0,
      gridLineWidth: 1,
      gridLineColor: "#f0f0f0",
      lineColor: "#ccd6eb",
      lineWidth: 1,
      labels: { style: { color: "#666666" } },
    }],
    legend: { enabled: false },
    plotOptions: {
      scatter: {
        marker: {
          radius: 4,
          symbol: "circle",
          fillColor: getSeriesColor(),
          lineWidth: 1,
          lineColor: "#fff",
          states: { hover: { enabled: true, lineColor: "#333" } },
        },
      },
    },
    tooltip: {
      formatter: function () {
        return `<b>${selectedAE.toUpperCase()} at ${this.point.name}</b><br/>
          ${selectedChart === "sfoc" ? "SFOC" : "RPM"}: <b>${this.y}${selectedChart === "sfoc" ? " g/kWh" : ""}</b>`;
      },
    },
    series: [
      { name: `${selectedAE.toUpperCase()} ${selectedChart === "sfoc" ? "SFOC" : "RPM"}`,
        data: scatterData,
        color: getSeriesColor(),
      },
    ],
  };

  useEffect(() => {
    if (chartRef.current && scatterData.length > 0) {
      chartRef.current.chart.series[0].update({ data: scatterData }, true);
    }
  }, [selectedChart, selectedAE, aeSfocVsRpmConsData]);

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
            <Gauge className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900">
            {selectedChart === "sfoc" ? "SFOC over MCR Load" : "RPM over MCR Load"}
          </h2>
        </div>
        <div className="flex gap-2">
          <button onClick={() => setSelectedChart("sfoc")} className={`px-3 py-1.5 text-sm rounded-md transition-colors ${selectedChart === "sfoc" ? "font-medium border" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`} style={selectedChart === "sfoc" ? { backgroundColor: "#e1f5fb", color: "#27ade3", borderColor: "#27ade3" } : {}}>SFOC</button>
          <button onClick={() => setSelectedChart("rpm")} className={`px-3 py-1.5 text-sm rounded-md transition-colors ${selectedChart === "rpm" ? "font-medium border" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`} style={selectedChart === "rpm" ? { backgroundColor: "#e1f5fb", color: "#27ade3", borderColor: "#27ade3" } : {}}>RPM</button>
        </div>
      </div>

      {/* Chart - ALWAYS show the chart if we have data array, even if values are 0 */}
      <div className="p-4">
        <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
      </div>
    </div>
  );
};

export default AEMcrLoadComparisonChart;
